import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import type { EfetivacaoResponse } from '@/core/api/sicom-api/servicos/shared/efetivacao.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

import type { PreMedicoDTO, PreMedicoRequest, PreMedicoResponse } from './pre-medico.model';

@Injectable({ providedIn: 'root' })
export class PreMedicoService extends BaseService {
    readonly PATH = SICOM_PATHS.servicos.pessoaFisica.preMedico;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    consultar(params: PreMedicoRequest, context?: HttpContext): Observable<PreMedicoResponse> {
        const httpParams = new HttpParams().set('numeroProtocolo', params.numeroProtocolo).set('anoProtocolo', params.anoProtocolo).set('uf_crm', params.ufCrm);
        return this.http.get<PreMedicoResponse>(this.PATH, { params: httpParams, context });
    }

    consultarAbertos(ufCrm: string, context?: HttpContext): Observable<Record<string, unknown>[]> {
        const httpParams = new HttpParams().set('uf_crm', ufCrm);
        return this.http.get<Record<string, unknown>[]>(`${this.PATH}/abertos`, { params: httpParams, context });
    }

    efetivarSolicitacao(dto: PreMedicoResponse, context?: HttpContext): Observable<EfetivacaoResponse> {
        return this.http.put<EfetivacaoResponse>(`${this.PATH}/efetivarSolicitacao`, dto, { context });
    }

    cancelarSolicitacao(dto: PreMedicoResponse, motivo?: string, context?: HttpContext): Observable<void> {
        const params = motivo ? new HttpParams().set('motivo', motivo) : undefined;
        return this.http.put<void>(`${this.PATH}/cancelarSolicitacao`, dto, { params, context });
    }

    atualizarCadastro(dto: PreMedicoDTO, context?: HttpContext): Observable<void> {
        return this.http.put<void>(`${this.PATH}/atualizarCadastro`, dto, { context });
    }

    atualizarDados(dto: PreMedicoDTO, context?: HttpContext): Observable<void> {
        return this.http.put<void>(`${this.PATH}/atualizarDados`, dto, { context });
    }
}
